import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';
import { EActivityType } from '../enum/activity-type.enum';

export class ActivityType extends PrimitiveValueObject<EActivityType> {
  static create(value: EActivityType): ActivityType {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new ActivityType(value);
  }
}
